import { render, staticRenderFns } from "./QuickIn.vue?vue&type=template&id=f5b086de"
import script from "./QuickIn.vue?vue&type=script&setup=true&lang=js"
export * from "./QuickIn.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports